import { useMemo } from "react";
import type { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";
import type { UserBasedAuthorization, UserForSharing } from "../../../../../../../../../api/types/svTypes.ts";
import type { CurrentUser } from "../ShareReport.types.ts";
import AuthorizedUsersList from "./AuthorizedUsersList.tsx";
import { buildAuthorizedUserItems } from "./authorizedItems.ts";

interface AuthorizedUsersProps {
  currentUser: CurrentUser;
  currentUserAccess: ReportAccessType;
  allUsers: UserForSharing[];
  authorizedUsers: UserBasedAuthorization[];
  disabled: boolean;
  onAccessChanged: (userId: string, access: ReportAccessType) => void;
  onRemoveUser: (userId: string) => void;
}

export default function AuthorizedUsers({
  currentUser,
  currentUserAccess,
  authorizedUsers,
  allUsers,
  disabled,
  onAccessChanged,
  onRemoveUser,
}: AuthorizedUsersProps) {
  const items = useMemo(
    () => buildAuthorizedUserItems(authorizedUsers, allUsers, currentUser.id, currentUserAccess),
    [authorizedUsers, allUsers, currentUser.id, currentUserAccess]
  );

  if (items.length === 0) {
    return null;
  }

  return (
    <AuthorizedUsersList
      items={items}
      disabled={disabled}
      onAccessChanged={onAccessChanged}
      onRemoveUser={onRemoveUser}
    />
  );
}
